import React from "react";
import config from "../../../config";

/**
 * ImageElement component for rendering images based on the provided source or default image.
 * @param {Object} props - Component properties.
 * @param {string} props.previewSource - Preview image source.
 * @param {string} props.source - Image source.
 * @param {string} props.imageFor - Type of image (e.g., "user" or "admin").
 * @param {string} props.alt - Alternative text for the image.
 * @param {string} props.origin - Cross-origin attribute for the image.
 * @param {Object} props.rest - Additional props for the image element.
 * @returns {JSX.Element} - Rendered ImageElement component.
 */
function ImageElement({
  previewSource = "",
  source,
  imageFor = "user",
  alt = "image",
  origin = "anonymous",
  ...rest
}) {
  // Define image paths based on imageFor type
  const imagePath = {
    user: config.IMAGE_URL,
    admin: config.ADMIN_IMAGE_URL,
  };
  return (
    <>
      {previewSource ? (
        <img src={previewSource} alt={alt} {...rest} />
      ) : (
        <>
          {source ? (
            <img
              src={`${imagePath[imageFor]}/${source}`}
              crossOrigin={origin}
              alt={alt}
              {...rest}
            />
          ) : (
            <img
              src={`${imagePath[imageFor]}/profile-img.jpg`}
              alt="userImage"
            />
          )}
        </>
      )}
    </>
  );
}

export default ImageElement;
